import React, { useEffect, useState } from "react";
import { ClientService } from "../services/ClientService.js";
import "./DevisClientPicker.css";

export default function DevisClientPicker({ onClose, onSelect }) {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClients = async () => {
      try {
        const service = new ClientService();
        const data = await service.getAllClients();
        setClients(data);
      } catch (e) {
        console.error("Error loading clients", e);
      } finally {
        setLoading(false);
      }
    };
    loadClients();
  }, []);

  const handleConfirm = () => {
    if (selectedClient) {
      onSelect(selectedClient); // Renvoie l'objet client entier au parent
    }
    onClose();
  };

  if (loading) return <div className="picker-overlay"><div className="picker-container"><p>Chargement des clients...</p></div></div>;

  return (
    <div className="picker-overlay">
      <div className="picker-container">
        <h2 className="picker-title">Sélectionner un Client</h2>
        
        <div className="picker-table-wrapper">
          <table className="picker-table">
            <thead>
              <tr>
                <th style={{ width: '40px' }}></th>
                <th>Nom / Société</th>
                <th>Email</th>
                <th>Téléphone</th>
              </tr>
            </thead>
            <tbody>
              {clients.length === 0 ? (
                <tr><td colSpan="4" style={{ textAlign: "center", padding: "20px" }}>Aucun client trouvé</td></tr>
              ) : (
                clients.map((c) => (
                  <tr 
                    key={c.id} 
                    className={`picker-row ${selectedClient?.id === c.id ? "selected" : ""}`}
                    onClick={() => setSelectedClient(c)}
                  >
                    <td>
                      <input 
                        type="radio" 
                        name="clientSelect" 
                        checked={selectedClient?.id === c.id} 
                        onChange={() => setSelectedClient(c)} 
                      />
                    </td>
                    <td>{c.nom || c.societe1 || 'N/A'}</td>
                    <td>{c.email || 'N/A'}</td>
                    <td>{c.telephone || 'N/A'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="picker-actions">
          <button className="picker-btn" onClick={handleConfirm} disabled={!selectedClient}>
            Sélectionner
          </button>
          <button className="picker-btn-secondary" onClick={onClose}>
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}